import { render } from "./TemporizadorVue.vue?vue&type=template&id=2ba832c2&ts=true"
import script from "./TemporizadorVue.vue?vue&type=script&lang=ts"
export * from "./TemporizadorVue.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__